module.exports = __webpack_public_path__ + "static/img/mobile-02.f24489aa.jpg";